import api from './api';

const BASE = '/api/bills';

export const getBills = () => api.get(BASE);

export const createBill = (payload) => api.post(BASE, payload);

export const updateBill = (id, payload) => api.patch(`${BASE}/${id}`, payload);

// Mark as Paid sends multipart FormData (paymentMethod, paidDate, and the compulsory proof file).
export const payBill = (id, formData) =>
  api.post(`${BASE}/${id}/pay`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const cancelBill = (id, reason) => api.post(`${BASE}/${id}/cancel`, { reason });

export const getBillVendors = () => api.get(`${BASE}/vendors`);

export const deleteBill = (id) => api.delete(`${BASE}/${id}`);
